// extracted by mini-css-extract-plugin
module.exports = {"button_date":"dashboard_button_date__vl6Uz"};